module.exports = __webpack_public_path__ + "static/1-6e25aa64ae71a316ebfe45169e5c2e56.jpg";